/*export const utilNumberToCurrency = (number: number | undefined, format?: boolean): string => {
  if (number && !format) {
    return `€ ${number}`;
  } else if (number && format) {
    const formatter = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });
    return formatter.format(number);
  }

  return '';
};*/

import { SymbolsData } from '@formatjs/ecma402-abstract/types/number';

export const utilNumberToCurrency = (number = 0, format = true, digits = 2): string => {
  if (!number) return '';

  if (format) {
    const formatter = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: digits,
      minimumFractionDigits: digits
    });
    return formatter.format(number);
  }

  return `€ ${number}`;
};

export const currencyToNumber = (value: string | number, mustBeNumber = false): number => {
  if (typeof value === 'number') return value;
  if (mustBeNumber && !value) return 0;

  if (value) {
    let formattedValue = parseFloat(value.replace(/€|\s|\./g, '').replace(',', '.'));
    formattedValue = isNaN(formattedValue) ? 0 : formattedValue;
    return formattedValue;
  }
  return 0;
};

export const percentageToFloat = (value: string): number => {
  let formattedValue = value.replaceAll('%', '');
  formattedValue = formattedValue.replaceAll(',', '.');
  return parseFloat(formattedValue);
};

export const floatToPercentage = (value: number): string => {
  return value.toString().replace('.', ',');
};

// convert string true to boolean true
export const stringToBoolean = (value: string): boolean => {
  if (value === 'true' || value === 'false') {
    return value === 'true';
  }
  return false;
};

export const generateSequentialArray = (value: number): number[] => {
  console.log(value);
  const array = Array.from({ length: value + 1 }, (_, i) => i);
  console.log(array);
  return array;
};

export const utilStringToNumber = (value: string): number => {
  if (value) {
    return parseInt(value);
  }

  return 0;
};

export const utilToLocaleString = (value: number, format = 'nl-NL'): string => {
  if (!value) {
    return '';
  }
  return value.toLocaleString(format);
};

export const utilNumberFormat = (
  value: number,
  locale: 'nl-NL' | 'en-US' = 'nl-NL',
  style: keyof SymbolsData = 'decimal'
): string => {
  return new Intl.NumberFormat(locale, {
    style
  }).format(value);
};
